import * as Sentry from "@sentry/browser";
import { Observable } from "rxjs";
import { COLLECTIONS } from "constants/action-types";
import { SentryScope } from "constants/sentry-metrics";

export const onCollectionFetched = (action$) =>
    action$.ofType(COLLECTIONS.COLLECTION.FETCH.COMPLETED).concatMap(({ payload, error }) => {
        Sentry.configureScope(function (scope) {
            if (error) {
                // Clear collection related scopes
                scope.setTag(SentryScope.collection.id, null);
                scope.setTag(SentryScope.collection.merchantId, null);
            } else {
                const {
                    collection: { id, merchant_id },
                } = payload;
                scope.setTag(SentryScope.collection.id, id);
                scope.setTag(SentryScope.collection.merchantId, merchant_id);
            }
        });

        return Observable.empty();
    });

export const onCollectionClear = (action$) =>
    action$.ofType(COLLECTIONS.COLLECTION.CLEAR).concatMap(() => {
        Sentry.configureScope(function (scope) {
            // Clear collection related scopes
            scope.setTag(SentryScope.collection.id, null);
            scope.setTag(SentryScope.collection.merchantId, null);
        });

        return Observable.empty();
    });
